import React from 'react'
import { injectIntl } from 'react-intl'
import PropTypes from 'prop-types'

import ModemReplacementStep1 from './ModemReplacementStep1'
import ModemReplacementStep2 from './ModemReplacementStep2'
import ModemReplacementStep3 from './ModemReplacementStep3'
import ModemReplacementStep4 from './ModemReplacementStep4'

import {
  CapitalButton,
} from '../../Navigation/Buttons'

// Styles
import styles from '../../../../../css/devicePage.module.css'

function ModemReplacement (props) {
  const {
    devices,
    params,
    page,
    data,
    previousPage,
    nextPage,
    submitFinished,
    setSkipInit,
  } = props

  const skipInstructions = (
    <CapitalButton
      text='Skip Instructions'
      buttonFunction={setSkipInit}
      hSize='h5'
      style={`${styles.selectAllButton} ${styles.selectAllButtonStyles}`}
    />
  )

  return (
    <div style={{ marginBottom: '20px' }}>
      <div>
        {page === 1 &&
                        (
                          <ModemReplacementStep1
                            devices={devices}
                            params={params}
                            data={data}
                            previousPage={previousPage}
                            nextPage={nextPage}
                            skipInstructions={skipInstructions}
                          />
                        )}
        {page === 2 &&
                        (
                          <ModemReplacementStep2
                            device={devices}
                            params={params}
                            data={data}
                            previousPage={previousPage}
                            nextPage={nextPage}
                            skipInstructions={skipInstructions}
                          />
                        )}
        {page === 3 &&
                        (
                          <ModemReplacementStep3
                            device={devices}
                            params={params}
                            data={data}
                            previousPage={previousPage}
                            nextPage={nextPage}
                            skipInstructions={skipInstructions}
                          />
                        )}
        {page === 4 &&
                        (
                          <ModemReplacementStep4
                            device={devices}
                            params={params}
                            data={data}
                            previousPage={previousPage}
                            submitFinished={submitFinished}
                          />
                        )}
      </div>

    </div>
  )
}

ModemReplacement.propTypes = {
  devices: PropTypes.object.isRequired,
  setSkipInit: PropTypes.func.isRequired,
  nextPage: PropTypes.func.isRequired,
  submitFinished: PropTypes.func.isRequired,
  params: PropTypes.object.isRequired,
  data: PropTypes.object.isRequired,
  page: PropTypes.number.isRequired,
  previousPage: PropTypes.func.isRequired,
}

export default injectIntl(ModemReplacement)
